export default __webpack_public_path__ + "static/media/24.71fc0651.wav";